import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { SignUpModal } from 'src/components/global/SignUpModal'
import { StarRating } from 'src/components/global/StarRating'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { VerifyEmailModal } from 'src/components/global/VerifyEmailModal'
import { IEnum_Solution_Type } from 'src/graphql/generated/hooks'
import { useAuthenticated } from 'src/hooks/useAuthenticated'

import { SubmitReviewModal } from '../SubmitReviewModal/SubmitReviewModal'

interface ReviewWithLinkItemProps {
  reviewCnt?: number
  starCnt: number
  title: string
  solutionType: IEnum_Solution_Type
  isEnhanced: boolean
  id: string
  href: string
}

export const ReviewWithLinkItem: React.FC<ReviewWithLinkItemProps> = ({
  reviewCnt = 0,
  starCnt = 0,
  title,
  solutionType,
  isEnhanced,
  id,
  href,
}) => {
  const router = useRouter()
  const { status, session } = useAuthenticated()
  const email = session?.user.email || ''
  const confirmed = session?.user.confirmed || false
  const [showSignUp, setShowSignUp] = useState(false)
  const [showEmailVerify, setShowEmailVerify] = useState(false)
  const [showModalDlg, setShowModalDlg] = useState(false)

  const handleShowReviewModal = () => {
    if (status !== 'authenticated') {
      setShowSignUp(true)
    } else if (confirmed === false) {
      setShowEmailVerify(true)
    } else {
      let link = ''
      if (href.includes('?')) {
        link = `${href}&from=submitReview&modal=true`
      } else {
        link = `${href}?from=submitReview&modal=true`
      }

      router.push(link)
    }
  }

  const handleCloseEditDlg = () => {
    setShowModalDlg(false)
  }

  const handleCloseSignUp = () => {
    setShowSignUp(false)
  }

  const handleCloseEmailVerify = () => {
    setShowEmailVerify(false)
  }
  const page = router.pathname
  const params = router.query
  return (
    <div className="flex flex-row items-center">
      <StarRating value={starCnt} type={0} readOnly={true} />
      <ThemeOnly theme="legaltech">
        <a
          className="font-primary font-bold text-[#559187] underline pl-2 cursor-pointer"
          onClick={() => handleShowReviewModal()}
        >
          Write a Review
        </a>
      </ThemeOnly>

      <ThemeOnly theme="ilta">
        <span className="ml-1 font-bold text-[14px]">{starCnt}</span>
      </ThemeOnly>

      <ThemeOnly theme="ilta">
        <span className="ml-1 text-[12px]">({reviewCnt} reveiews)</span>
      </ThemeOnly>

      <SignUpModal isOpen={showSignUp} onClose={handleCloseSignUp} page={page} params={JSON.stringify(params)} />
      <VerifyEmailModal isOpen={showEmailVerify} email={email} onClose={handleCloseEmailVerify} />
      <SubmitReviewModal
        isOpen={showModalDlg}
        vendorName={title}
        solutionType={solutionType}
        id={id}
        isEnhanced={isEnhanced}
        onClose={handleCloseEditDlg}
      />
    </div>
  )
}
